'use strict';

const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const jstz=require('jstimezonedetect');

const USIanaTimeZones=[
'America/New_York',
'America/Detroit',
'America/Kentucky/Louisville',
'America/Kentucky/Monticello',
'America/Indiana/Indianapolis',
'America/Indiana/Vincennes',
'America/Indiana/Winamac',
'America/Indiana/Marengo',
'America/Indiana/Petersburg',
'America/Indiana/Vevay',
'America/Chicago',
'America/Indiana/Tell_City',
'America/Indiana/Knox',
'America/Menominee',
'America/North_Dakota/Center',
'America/North_Dakota/New_Salem',
'America/North_Dakota/Beulah',
'America/Denver',
'America/Boise',
'America/Phoenix',
'America/Los_Angeles',
'America/Anchorage',
'America/Juneau',
'America/Sitka',
'America/Metlakatla',
'America/Yakutat',
'America/Nome',
'America/Adak',
'Pacific/Honolulu'];let


TimeZoneService=class TimeZoneService extends BaseService{
static get $inject(){return[]}

constructor(){
super();

this.__actualLocalTimeZone=jstz.determine().name();

this.reset();
}

reset(){
this._localTimeZone=this.__actualLocalTimeZone;
}

setMockTimeZone(timeZone){
this._localTimeZone=timeZone;
}

get isMocked(){
return this._localTimeZone!==this.__actualLocalTimeZone;
}

get localTimeZone(){
return this._localTimeZone;
}

get USIanaTimeZones(){
return USIanaTimeZones;
}};


module.exports=TimeZoneService;
//# sourceMappingURL=timeZoneService.js.map
